import React from 'react';
import { Flex, Text, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../../../../../../../../../../constants/cypressIds';
import { getDateString } from '../../../../../../../../../../../../../utils/dateUtil';

const ExpirationDateCellPopover = ({ document }) => {
  const policies = document.policies || [];
  const expirations = document.expirations || [];

  if (!policies.length && !expirations.length) {
    return (
      <Text data-cy={CypressIds.documentExpiredIconButtonPopover(document.id)} fontSize="sm">
        No expirations
      </Text>
    );
  }

  return (
    <VStack align="stretch" data-cy={CypressIds.documentExpiredIconButtonPopover(document.id)} spacing={2}>
      {policies.map(p => (
        <Flex direction="column" fontSize="sm" justifyContent="flex-start" key={`policy-${p.id}`} width="100%">
          <Text>
            {p?.insurancePolicyType?.displayName}
            {' - '}
            {p?.number}
          </Text>
          <Text>
            Expires
            {' '}
            {getDateString(p?.expiresAt, 'MM/DD/YYYY')}
          </Text>
        </Flex>
      ))}
      {expirations.map(e => (
        <Flex direction="column" fontSize="sm" justifyContent="flex-start" key={`expiration-${e.id}`} width="100%">
          <Text>{e.insurancePolicyType?.displayName || e.name || 'Custom Expiration'}</Text>
          <Text>
            Expires
            {' '}
            {getDateString(e.expiresAt, 'MM/DD/YYYY')}
          </Text>
        </Flex>
      ))}
    </VStack>
  );
};

ExpirationDateCellPopover.propTypes = {
  document: PropTypes.shape({
    id: PropTypes.number,
    policies: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      number: PropTypes.string,
      expiresAt: PropTypes.string,
      insurancePolicyType: PropTypes.shape({ displayName: PropTypes.string })
    })),
    expirations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      expiresAt: PropTypes.string
    }))
  }).isRequired
};

export default ExpirationDateCellPopover;
